export async function insertText(...text: string[]) {
  try {
    await Word.run(async (context) => {
      let body = context.document.body;
      body.insertParagraph(text[0], Word.InsertLocation.end);
      await context.sync();
    });
  } catch (error) {
    console.log("Error: " + error);
  }

  if (text.length > 1) {
    const [first, ...rest] = text;
    return insertText(...rest);
  }
}
